import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import * as autoThunks from 'features/auto-thunks'
import MobileLoginProxy from './mobile-login-proxy-model'
import {
  CreateMobileLoginProxyAsync,
  DeleteMobileLoginProxyAsync,
  LoadMobileLoginProxysAsync,
} from './mobileLoginProxy-thunk'
const initialState: mobileLoginProxySliceState = {
  mobileLoginProxy: [],
  selected_mobileLoginProxy: '',
  is_loading_mobileLoginProxy: false,
  is_creating_mobileLoginProxy: false,
  is_deleting_mobileLoginProxy: false,
}
export interface mobileLoginProxySliceState {
  mobileLoginProxy: MobileLoginProxy[]
  selected_mobileLoginProxy?: string
  is_loading_mobileLoginProxy: boolean
  is_creating_mobileLoginProxy: boolean
  is_deleting_mobileLoginProxy: boolean
}
export const mobileLoginProxySlice = createSlice({
  name: 'mobileLoginProxy',
  initialState,
  reducers: {
    setSelectedmobileLoginProxy: (state, action) => {
      state.selected_mobileLoginProxy = action.payload
    },
    clearStatemobileLoginProxy: (state) => {
      state.mobileLoginProxy = []
      state.is_loading_mobileLoginProxy = false
      state.is_creating_mobileLoginProxy = false
      state.is_deleting_mobileLoginProxy = false
    },
    mergemobileLoginProxy: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_mobileLoginProxy = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.mobileLoginProxy = merge(state.mobileLoginProxy, payload) as any
        }
      }
    },

    add_mobileLoginProxy: (state, action) => {
      if (action.payload) {
        state.mobileLoginProxy = [...state.mobileLoginProxy, action.payload]
      }
    },
    set_mobileLoginProxy: (state, action) => {
      let { key, value, id } = action.payload
      state.mobileLoginProxy = state.mobileLoginProxy.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadMobileLoginProxysAsync.pending, (state) => {
      state.is_loading_mobileLoginProxy = true
    })
    builder.addCase(LoadMobileLoginProxysAsync.fulfilled, (state, action) => {
      state.is_loading_mobileLoginProxy = false
      if (action.payload) {
        state.mobileLoginProxy = action.payload
      }
    })
    builder.addCase(LoadMobileLoginProxysAsync.rejected, (state) => {
      state.is_loading_mobileLoginProxy = false
    })
    builder.addCase(CreateMobileLoginProxyAsync.pending, (state) => {
      state.is_creating_mobileLoginProxy = true
    })
    builder.addCase(CreateMobileLoginProxyAsync.fulfilled, (state) => {
      state.is_creating_mobileLoginProxy = false
    })
    builder.addCase(CreateMobileLoginProxyAsync.rejected, (state) => {
      state.is_creating_mobileLoginProxy = false
    })
    builder.addCase(DeleteMobileLoginProxyAsync.pending, (state) => {
      state.is_deleting_mobileLoginProxy = true
    })
    builder.addCase(DeleteMobileLoginProxyAsync.fulfilled, (state, action) => {
      state.is_deleting_mobileLoginProxy = false
      if (state.mobileLoginProxy) {
        state.mobileLoginProxy = state.mobileLoginProxy.filter(
          (x) => action.payload.id !== x.id,
        )
      }
    })
    builder.addCase(DeleteMobileLoginProxyAsync.rejected, (state) => {
      state.is_deleting_mobileLoginProxy = false
    })

    builder.addCase(autoThunks.get_mobile_login_proxies.pending, (state) => {
      state.is_loading_mobileLoginProxy = true
    })
    builder.addCase(
      autoThunks.get_mobile_login_proxies.fulfilled,
      (state, action) => {
        state.is_loading_mobileLoginProxy = false
        handleResult(action, state)
      },
    )
    builder.addCase(autoThunks.get_mobile_login_proxies.rejected, (state) => {
      state.is_loading_mobileLoginProxy = false
    })

    builder.addCase(
      autoThunks.connect_to_mobile_login_proxy.pending,
      (state) => {
        state.is_loading_mobileLoginProxy = true
      },
    )
    builder.addCase(
      autoThunks.connect_to_mobile_login_proxy.fulfilled,
      (state, action) => {
        state.is_loading_mobileLoginProxy = false
        handleResult(action, state)
      },
    )
    builder.addCase(
      autoThunks.connect_to_mobile_login_proxy.rejected,
      (state) => {
        state.is_loading_mobileLoginProxy = false
      },
    )
  },
})

function handleResult(action: any, state: mobileLoginProxySliceState) {
  if (action.payload) {
    let payload: any = action.payload
    if (payload?.data) {
      if (!Array.isArray(payload.data)) {
        state.selected_mobileLoginProxy = payload?.data?.id
        payload = [payload.data]
      } else {
        payload = payload.data
      }
      state.mobileLoginProxy = merge(state.mobileLoginProxy, payload) as any
    }
  }
}

export const {
  clearStatemobileLoginProxy,
  setSelectedmobileLoginProxy,
  set_mobileLoginProxy,
  mergemobileLoginProxy,
  add_mobileLoginProxy,
} = mobileLoginProxySlice.actions

export const get_mobileLoginProxy =
  (id?: string) =>
  (state: {
    mobileLoginProxy: {
      mobileLoginProxy: MobileLoginProxy[]
    }
  }): MobileLoginProxy | null => {
    let temp = state?.mobileLoginProxy?.mobileLoginProxy?.find(
      (v) => v.id === id,
    )
    if (temp) {
      return temp
    }
    return state?.mobileLoginProxy?.mobileLoginProxy[0] || null
  }
export const get_selected_mobileLoginProxy = (state: {
  mobileLoginProxy: mobileLoginProxySliceState
}): MobileLoginProxy | null => {
  let id = state?.mobileLoginProxy?.selected_mobileLoginProxy
  let temp = state?.mobileLoginProxy?.mobileLoginProxy?.find((v) => v.id === id)
  if (temp) {
    return temp
  }
  return null
}
export const get_all_mobileLoginProxy = (state: {
  mobileLoginProxy: {
    mobileLoginProxy: MobileLoginProxy[]
  }
}): MobileLoginProxy[] => {
  let temp = state?.mobileLoginProxy?.mobileLoginProxy
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_mobileLoginProxy_busy = (state: {
  mobileLoginProxy: mobileLoginProxySliceState
}) => {
  return (
    state?.mobileLoginProxy.is_deleting_mobileLoginProxy ||
    state?.mobileLoginProxy.is_loading_mobileLoginProxy ||
    state?.mobileLoginProxy.is_creating_mobileLoginProxy
  )
}
export const is_deleting_mobileLoginProxy_busy = (state: {
  mobileLoginProxy: mobileLoginProxySliceState
}) => {
  return state?.mobileLoginProxy.is_deleting_mobileLoginProxy
}
export const is_loading_mobileLoginProxy_busy = (state: {
  mobileLoginProxy: mobileLoginProxySliceState
}) => {
  return state?.mobileLoginProxy.is_loading_mobileLoginProxy
}
export const is_creating_mobileLoginProxy_busy = (state: {
  mobileLoginProxy: mobileLoginProxySliceState
}) => {
  return state?.mobileLoginProxy.is_creating_mobileLoginProxy
}

export default mobileLoginProxySlice.reducer
